import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-codes-div',
  templateUrl: './codes-div.component.html',
  styleUrls: ['./codes-div.component.css']
})
export class CodesDivComponent implements OnInit {

  constructor() { }

  @Input() list;
  @Input() id;
  @Input() imageWidth;
  @Input() imageDouble;


  ngOnInit() {
  }

}
